export enum BoolEnum {
     False = 0,
     True = 1,
  }